import { RailAction } from '@/components/v2/organisms/admin/tabs/AdminTodosTab/RightRailToggle';
import { Filter, PanelRightOpen, Plus, Search } from 'lucide-react';

interface Params {
  isBacklogOpen: boolean;
  toggleBacklog: () => void;
  showFilters: boolean;
  setShowFilters: (value: boolean | ((v: boolean) => boolean)) => void;
  handleCreateTaskClick: (date: Date | null) => void;
}

const getRightRailActions = ({
  isBacklogOpen,
  toggleBacklog,
  showFilters,
  setShowFilters,
  handleCreateTaskClick,
}: Params): RailAction[] => [
  {
    id: 'backlog',
    label: isBacklogOpen ? 'Ocultar Backlog' : 'Mostrar Backlog',
    icon: <PanelRightOpen className="h-3 w-3" />,
    shortcut: 'b',
    onTrigger: toggleBacklog,
    active: isBacklogOpen,
  },
  // {
  //   id: 'filters',
  //   label: showFilters ? 'Ocultar filtros' : 'Mostrar filtros',
  //   icon: <Filter className="h-3 w-3" />,
  //   shortcut: { key: 'f', ctrl: true },
  //   onTrigger: () => setShowFilters((v) => !v),
  //   active: showFilters,
  // },
  // {
  //   id: 'new-task',
  //   label: 'Nueva tarea',
  //   icon: <Plus className="h-3 w-3" />,
  //   shortcut: { key: 'n', meta: true },
  //   onTrigger: () => handleCreateTaskClick(null),
  // },
];

export default getRightRailActions;
